<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Select AP configuration</h3>
    <p class="modal-subtitle mb-0">
      Choose which accounting (AP) configuration to use for this client.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  @if (apConfigs === null) {
    <p class="modal-subtitle mb-0">Loading AP configurations…</p>
  } @else if (apConfigs.length === 0) {
    <div class="alert alert-info mb-0" role="alert">
      No AP configurations found for this client.
    </div>
  } @else {
    @if (requireClientManagedSupport && !hasSelectableApConfig()) {
      <div class="alert alert-info" role="alert">
        <strong>No eligible AP configurations for this client.</strong>
        <p class="mb-0 mt-1">
          Client Managed applies to Vantaca configurations past their v3
          cut-over date. This client has:
        </p>
      </div>
      <ul class="vive-blue_list mb-0">
        @for (apConfig of apConfigs; track apConfig.id) {
          <li>
            {{ getApConfigLabel(apConfig) }} —
            <span class="chip chip-neutral">{{
              getIneligibleReason(apConfig)
            }}</span>
          </li>
        }
      </ul>
    } @else {
      <div class="form-group mb-0">
        <label class="form-label" for="ap-config-select"
          >AP configuration</label
        >
        <select
          id="ap-config-select"
          class="form-select"
          [(ngModel)]="selectedApConfig"
        >
          <option disabled [ngValue]="null">Pick one…</option>
          @for (apConfig of apConfigs; track apConfig.id) {
            <option
              [ngValue]="apConfig"
              [disabled]="!isApConfigSelectable(apConfig)"
            >
              {{ getApConfigOptionLabel(apConfig) }}
            </option>
          }
        </select>
        @if (requireClientManagedSupport) {
          <small class="form-text">
            Only Vantaca configurations past their v3 cut-over date can take a
            Client Managed flag.
          </small>
        }
      </div>
    }
  }

  @if (showFilters) {
    <div class="form-group tag-field-group mt-4">
      <label class="form-label" for="keyword-tag-input"
        >Keywords (partial matching on AP Vendors by legal name)</label
      >
      <div class="tag-field" (click)="focusTagInput()">
        @for (tag of legalNames; track tag; let i = $index) {
          <span class="chip chip-info tag-chip">
            <span class="tag-chip-label">{{ tag }}</span>
            <button
              type="button"
              class="tag-chip-remove"
              [attr.aria-label]="'Remove ' + tag"
              (click)="removeTag(i, $event)"
            >
              <i class="bi bi-x"></i>
            </button>
          </span>
        }
        <span
          #tagInput
          id="keyword-tag-input"
          class="tag-field-input"
          role="textbox"
          contenteditable="true"
          aria-label="Add keywords, separated by commas"
          data-placeholder="Type words separated by commas…"
          (keydown.enter)="addTags($event)"
          (blur)="addTags($event)"
        ></span>
      </div>
      <small class="form-text tag-field-hint">
        Separate words with commas, then press Enter to create tags.
      </small>
    </div>

    <div class="form-group tag-field-group mt-4">
      <label class="form-label" for="accounting-id-tag-input"
        >Accounting IDs (exact matching on AP Vendors by accounting ID)</label
      >
      <div class="tag-field" (click)="focusapVendorKeyTagInput()">
        @for (tag of apVendorKeys; track tag; let i = $index) {
          <span class="chip chip-info tag-chip">
            <span class="tag-chip-label">{{ tag }}</span>
            <button
              type="button"
              class="tag-chip-remove"
              [attr.aria-label]="'Remove ' + tag"
              (click)="removeapVendorKeyTag(i, $event)"
            >
              <i class="bi bi-x"></i>
            </button>
          </span>
        }
        <span
          #apVendorKeyTagInput
          id="accounting-id-tag-input"
          class="tag-field-input"
          role="textbox"
          contenteditable="true"
          aria-label="Add accounting IDs, separated by commas"
          data-placeholder="Type accounting IDs separated by commas…"
          (keydown.enter)="addapVendorKeys($event)"
          (blur)="addapVendorKeys($event)"
        ></span>
      </div>
      <small class="form-text tag-field-hint">
        Separate accounting IDs with commas, then press Enter to create tags.
      </small>
    </div>
  }
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    @if (requireClientManagedSupport && apConfigs && !hasSelectableApConfig()) {
      <button type="button" class="btn btn-primary" (click)="close()">
        Close
      </button>
    } @else {
      <button type="button" class="btn btn-ghost" (click)="close()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!selectedApConfig"
        (click)="submit()"
      >
        Select
      </button>
    }
  </div>
</div>
